// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.its-panel {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.its-panel--status {
  padding: 1.25rem 0;
  text-align: center;
  color: var(--text-muted, #64748b);
  font-size: 0.9rem;
}

.its-panel--status i {
  margin-right: 0.4rem;
}

.its-panel__hint,
.its-panel__section-hint,
.its-panel__empty {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.45;
  color: var(--text-muted, #64748b);
}

.its-panel__alert {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  padding: 0.65rem 0.75rem;
  border-radius: 8px;
  font-size: 0.82rem;
}

.its-panel__alert--error {
  background: #fef2f2;
  color: #b91c1c;
}

.its-panel__alert--success {
  background: #ecfdf5;
  color: #047857;
}

.its-panel__retry {
  align-self: flex-start;
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.4rem 0.8rem;
  border-radius: 8px;
  border: 1px solid #0f766e;
  background: #fff;
  color: #0f766e;
  cursor: pointer;
}

.its-panel__section {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.85rem 0.95rem;
  background: #f8fafc;
}

.its-panel__section-title {
  margin: 0 0 0.35rem;
  font-size: 0.82rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #0f766e;
}

.its-panel__wallets {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 0.55rem;
  margin-top: 0.65rem;
}

.its-panel__wallet,
.its-panel__route {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0.45rem 0.6rem;
}

.its-panel__wallet-name {
  flex: 1 1;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text, #0f172a);
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.its-panel__lock {
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #b91c1c;
  background: #fef2f2;
  border-radius: 999px;
  padding: 0.1rem 0.4rem;
}

.its-panel__state {
  font-size: 0.72rem;
  font-weight: 700;
  min-width: 1.6rem;
}

.its-panel__state.is-on {
  color: #0f766e;
}

.its-panel__state.is-off {
  color: #64748b;
}

.its-panel__groups {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 0.55rem;
}

.its-panel__group-head {
  font-size: 0.78rem;
  font-weight: 700;
  color: #334155;
  margin-bottom: 0.4rem;
}

.its-panel__routes {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.its-panel__route-label {
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text, #0f172a);
}

.its-panel__route-label i {
  font-size: 0.65rem;
  color: #0f766e;
}

.modal.modal--transfer-settings {
  max-width: 640px;
}

.traders-table__transfers {
  text-align: center;
  width: 72px;
}

.btn-icon--transfer {
  background: #ecfdf5;
  color: #0f766e;
}

.btn-icon--transfer:hover {
  background: #14b8a6;
  color: #fff;
}

.btn-icon--transfer:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  transform: none;
}

.its-panel .traders-toggle {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  flex-shrink: 0;
  cursor: pointer;
}

.its-panel .traders-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.its-panel .traders-toggle__slider {
  position: absolute;
  inset: 0;
  background: #cbd5e1;
  border-radius: 28px;
  transition: 0.3s;
}

.its-panel .traders-toggle__slider::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: 0.3s;
}

.its-panel .traders-toggle input:checked + .traders-toggle__slider {
  background: linear-gradient(135deg, #0f766e, #14b8a6);
}

.its-panel .traders-toggle input:checked + .traders-toggle__slider::before {
  transform: translateX(20px);
}

.its-panel .traders-toggle input:disabled + .traders-toggle__slider {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Traders/InternalTransferSettingsPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;EAGE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".its-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.its-panel--status {\n  padding: 1.25rem 0;\n  text-align: center;\n  color: var(--text-muted, #64748b);\n  font-size: 0.9rem;\n}\n\n.its-panel--status i {\n  margin-right: 0.4rem;\n}\n\n.its-panel__hint,\n.its-panel__section-hint,\n.its-panel__empty {\n  margin: 0;\n  font-size: 0.8rem;\n  line-height: 1.45;\n  color: var(--text-muted, #64748b);\n}\n\n.its-panel__alert {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.45rem;\n  padding: 0.65rem 0.75rem;\n  border-radius: 8px;\n  font-size: 0.82rem;\n}\n\n.its-panel__alert--error {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.its-panel__alert--success {\n  background: #ecfdf5;\n  color: #047857;\n}\n\n.its-panel__retry {\n  align-self: flex-start;\n  font-family: inherit;\n  font-size: 0.82rem;\n  font-weight: 600;\n  padding: 0.4rem 0.8rem;\n  border-radius: 8px;\n  border: 1px solid #0f766e;\n  background: #fff;\n  color: #0f766e;\n  cursor: pointer;\n}\n\n.its-panel__section {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 0.85rem 0.95rem;\n  background: #f8fafc;\n}\n\n.its-panel__section-title {\n  margin: 0 0 0.35rem;\n  font-size: 0.82rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #0f766e;\n}\n\n.its-panel__wallets {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: 0.55rem;\n  margin-top: 0.65rem;\n}\n\n.its-panel__wallet,\n.its-panel__route {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 0.45rem 0.6rem;\n}\n\n.its-panel__wallet-name {\n  flex: 1;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text, #0f172a);\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.its-panel__lock {\n  font-size: 0.65rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #b91c1c;\n  background: #fef2f2;\n  border-radius: 999px;\n  padding: 0.1rem 0.4rem;\n}\n\n.its-panel__state {\n  font-size: 0.72rem;\n  font-weight: 700;\n  min-width: 1.6rem;\n}\n\n.its-panel__state.is-on {\n  color: #0f766e;\n}\n\n.its-panel__state.is-off {\n  color: #64748b;\n}\n\n.its-panel__groups {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-top: 0.55rem;\n}\n\n.its-panel__group-head {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #334155;\n  margin-bottom: 0.4rem;\n}\n\n.its-panel__routes {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.its-panel__route-label {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text, #0f172a);\n}\n\n.its-panel__route-label i {\n  font-size: 0.65rem;\n  color: #0f766e;\n}\n\n.modal.modal--transfer-settings {\n  max-width: 640px;\n}\n\n.traders-table__transfers {\n  text-align: center;\n  width: 72px;\n}\n\n.btn-icon--transfer {\n  background: #ecfdf5;\n  color: #0f766e;\n}\n\n.btn-icon--transfer:hover {\n  background: #14b8a6;\n  color: #fff;\n}\n\n.btn-icon--transfer:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.its-panel .traders-toggle {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n\n.its-panel .traders-toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.its-panel .traders-toggle__slider {\n  position: absolute;\n  inset: 0;\n  background: #cbd5e1;\n  border-radius: 28px;\n  transition: 0.3s;\n}\n\n.its-panel .traders-toggle__slider::before {\n  content: \"\";\n  position: absolute;\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background: #fff;\n  border-radius: 50%;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  transition: 0.3s;\n}\n\n.its-panel .traders-toggle input:checked + .traders-toggle__slider {\n  background: linear-gradient(135deg, #0f766e, #14b8a6);\n}\n\n.its-panel .traders-toggle input:checked + .traders-toggle__slider::before {\n  transform: translateX(20px);\n}\n\n.its-panel .traders-toggle input:disabled + .traders-toggle__slider {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
